import React from 'react';
type Variant = 'primary' | 'inverse';
interface CTAButtonProps {
  children: React.ReactNode;
  variant?: Variant;
  className?: string;
  size?: 'md' | 'lg';
  onClick?: () => void;
}
const CHECKOUT_URL = 'https://vitalizateahora.com/cart/52084969832679:1';
export function CTAButton({
  children,
  variant = 'primary',
  className = '',
  size = 'md',
  onClick
}: CTAButtonProps) {
  const base = 'inline-flex items-center justify-center rounded-[8px] font-medium no-underline transition-all duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-rose focus-visible:ring-offset-2';
  const variants: Record<Variant, string> = {
    primary: 'bg-wine text-white hover:bg-[#3a1020] hover:shadow-[0_8px_20px_rgba(75,21,40,0.25)] active:scale-[0.99]',
    inverse: 'bg-cream text-wine hover:bg-white hover:shadow-[0_8px_20px_rgba(0,0,0,0.15)] active:scale-[0.99]'
  };
  const sizes: Record<string, string> = {
    md: 'px-8 py-4 text-[16px]',
    lg: 'px-10 py-[18px] text-[18px]'
  };
  return <a href={CHECKOUT_URL} target="_top" rel="noopener" onClick={onClick} className={`${base} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-43">
      {children}
    </a>;
}